import { ObjectMapper } from 'json-object-mapper';
import { ApplicationTypeEnum } from 'services/enums/ApplicationType.enum';
import { CompetenceTypeEnum } from 'services/enums/CompetenceType.enum';
import { NineBoxAxiosTypeEnum } from 'services/enums/NineBoxAxiosType.enum';
import { IModel } from '../IModel';
import { Model, OptionModel } from '../model';
import { JobTitleCompetenceLevelModel } from './jobTitleCompetenceLevel.model';
import { CompetenceMatrixModel } from './competenceMatrix.model';

export class JobTitleCompetenceModel extends Model implements IModel<JobTitleCompetenceModel> {
  title: string = '';
  definition: string = '';
  companyGroupId: string | undefined = undefined;
  type: any = CompetenceTypeEnum.Behavioral.value;
  application: any = ApplicationTypeEnum.Global.value;
  nineBoxAxios: any = NineBoxAxiosTypeEnum.Performance.value;
  levelId?: string = '';
  parentId?: string = '';
  levelName: string = '';
  level: JobTitleCompetenceLevelModel;
  parent?: JobTitleCompetenceModel;
  children: JobTitleCompetenceModel[] = [];
  jobTitleGroupIds?: string[] = [];
  jobTitleFamilyIds?: string[] = [];
  jobTitleIds?: string[] = [];
  competenceMatrices?: CompetenceMatrixModel[] = [];
  companyRootIds?: string[] = [];

  get typeLabel(): string {
    const type = CompetenceTypeEnum.getBy(this.type);
    return `${type?.label}`;
  }

  get applicationLabel(): string {
    const application = ApplicationTypeEnum.getBy(this.application);
    return `${application?.label}`;
  }

  get nineBoxAxiosLabel(): string {
    const nineBox = NineBoxAxiosTypeEnum.getBy(this.nineBoxAxios);
    return `${nineBox?.label}`;
  }

  static create(input: any): JobTitleCompetenceModel {
    return ObjectMapper.deserialize<JobTitleCompetenceModel>(JobTitleCompetenceModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  toOption(): OptionModel {
    return { label: `${this.title}`, value: this.id } as OptionModel;
  }
}
